export default __webpack_public_path__ + "static/media/result.d323488d.svg";